import React from 'react';
import { useSelector } from 'react-redux';
import LoadingScreen from '~/components/SolvPatternLibrary/LoadingScreen';
import { SectionNumber } from '../../constants';
import { useAccountMatchesBooking } from '../../hooks/useAccountMatchesBooking';
import { useSetupSection } from '../../hooks/useSetupSection';
import { SectionNumberObj, SectionPageCollection } from '../../interfaces';
import InvalidPhoneNumber from '../../InvalidPhoneNumber';
import PaperworkLayout from '../../PaperworkLayout';
import { PGSectionNumber } from '../../providerGroups/constants';
import GenericSectionForm from './GenericSectionForm';

export const GenericSection = <Sect extends SectionNumber | PGSectionNumber>({
  sectionValue,
  section,
  pageCollection,
  formComponent = GenericSectionForm,
  extraFormProps,
}: {
  sectionValue: Sect;
  section: SectionNumberObj<Sect>;
  pageCollection: SectionPageCollection;
  formComponent?: any;
  extraFormProps?: any;
}) => {
  const { onGoForward, onGoBack, title, subtitle, handleClickNext } = useSetupSection(
    sectionValue,
    section,
    sectionValue === SectionNumber.Custom ? pageCollection : {}
  );

  const paperwork = useSelector((state) => state.paperwork);

  const sectionPage = pageCollection.get(paperwork.pageView);

  const doesAccountMatchBooking = useAccountMatchesBooking();

  if (!paperwork || !paperwork.standardFields || !sectionPage) {
    return <LoadingScreen />;
  }

  if (!doesAccountMatchBooking) {
    return <InvalidPhoneNumber />;
  }

  const FormComponent = formComponent;

  return (
    <PaperworkLayout onGoBack={onGoBack} section={sectionValue} subtitle={subtitle} title={title}>
      <FormComponent
        handleClickNext={handleClickNext}
        onGoForward={onGoForward}
        pageInSection={paperwork.pageView}
        sectionPage={sectionPage}
        {...extraFormProps}
      />
    </PaperworkLayout>
  );
};
